<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<ng-container *ngIf="!loading">
  <header class="page-head">
    <div><h1>我的工单</h1></div>
    <button class="outline-btn" (click)="checkForm()">
      我的工单
      <span id="count">{{ openList.length > 0 ? openList.length : "" }}</span>
    </button>
  </header>
  <section class="status-card" *ngIf="openList.length > 0">
    <div class="status-left">
      <div class="status-icon">↻</div>
      <div class="status-copy">
        <div>
          <span class="pill processing">{{ status(openList[0].status) }}</span>
          <strong>
            {{ openList[0].platform?.name }} ·
            {{ openList[0].bus_seat.bus.bus_account?.username }}
          </strong>
        </div>
      </div>
    </div>
    <button class="secondary-btn" (click)="checkFormDetail(openList[0].id)">
      查看进度
    </button>
  </section>
  <section class="panel">
    <div class="panel-top">
      <button
        class="back-btn"
        (click)="back()"
        [ngStyle]="{ opacity: index === 1 ? '0' : '' }"
      >
        <span>←</span>
        返回上一步
      </button>
      <div class="steps">
        <div class="step" [class]="index === 1 ? 'active' : ''">
          <span>选择账号</span>
        </div>
        <i class="sep"></i>
        <div class="step" [class]="index === 2 ? 'active' : ''">
          <span>选择问题</span>
        </div>
        <i class="sep"></i>
        <div class="step" [class]="index === 3 ? 'active' : ''">
          <span>处理方式</span>
        </div>
        <i class="sep"></i>
        <div class="step" [class]="index === 4 ? 'active' : ''">
          <span>处理进度</span>
        </div>
      </div>
    </div>
    <section
      class="view"
      [class]="index === 1 ? 'active' : ''"
      *ngIf="index === 1"
    >
      <app-support1-panel
        [demoData]="guideMode ? demoSeats : null"
        (next)="change1($event)"
      ></app-support1-panel>
    </section>
    <section
      class="view"
      [class]="index === 2 ? 'active' : ''"
      *ngIf="index === 2"
    >
      <app-support2-panel
        (back)="index = $event"
        [platformInfo]="platformInfo"
        [demoData]="guideMode ? demoProblems : null"
        (next)="change2($event)"
      ></app-support2-panel>
    </section>
    <section
      class="view"
      [class]="index === 3 ? 'active' : ''"
      *ngIf="index === 3"
    >
      <app-support3-panel
        (back)="index = $event"
        [platformInfo]="platformInfo"
        [problemInfo]="problemInfo"
        (next)="change3($event)"
      ></app-support3-panel>
    </section>
    <section
      class="view"
      [class]="index === 4 ? 'active' : ''"
      *ngIf="index === 4"
    >
      <app-support4-panel
        [platformInfo]="platformInfo"
        [problemInfo]="problemInfo"
        [ticket]="ticket"
      ></app-support4-panel>
    </section>
  </section>

  <!-- 新手引导（游戏式教程）：首次进入页面自动弹出，完成后不再展示 -->
  <app-support-guide
    #guide
    [steps]="guideSteps"
    (finished)="onGuideFinished()"
    (dismissed)="onGuideDismissed()"
  ></app-support-guide>
</ng-container>
